export const getReportSchemaVersion = report => report.getIn(['config', 'unifiedEvent', 'schemaVersion']);
export const getReportSchemaReportType = report => report.getIn(['config', 'unifiedEvent', 'reportType']);